/**
 * CalendarDay — one day button in the date field's calendar. Disabled before
 * the minimum date; the chosen day is filled and today is outlined.
 */
import { format } from 'date-fns';

import { viewerDate } from '../../../utils/viewer-date';

function dayStyle(selected: boolean, today: boolean, disabled: boolean): React.CSSProperties {
  return {
    height: 30,
    border: today && !selected ? '1px solid var(--nb-border-2)' : '1px solid transparent',
    borderRadius: 6,
    fontSize: 12,
    cursor: disabled ? 'default' : 'pointer',
    background: selected ? 'var(--nb-primary)' : 'transparent',
    color: selected ? 'var(--nb-bg)' : disabled ? 'var(--nb-faint)' : 'var(--nb-ink)',
    fontWeight: selected ? 700 : 500,
  };
}

/** Local-calendar Date for a `YYYY-MM-DD`, for formatting only. */
const asLocal = (value: string) => {
  const [y, m, d] = value.split('-').map(Number);
  return new Date(y, m - 1, d);
};

export function CalendarDay({
  value,
  selected,
  min,
  onPick,
}: {
  value: string;
  selected: boolean;
  min?: string;
  onPick: (value: string) => void;
}) {
  const disabled = min !== undefined && value < min;
  return (
    <button
      type="button"
      aria-label={format(asLocal(value), 'EEEE, MMMM d, yyyy')}
      aria-pressed={selected}
      disabled={disabled}
      onClick={() => onPick(value)}
      style={dayStyle(selected, value === viewerDate(), disabled)}
    >
      {Number(value.slice(8))}
    </button>
  );
}
